import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { Withholding } from "../models/withholding";
import { FilterWithholdingCatalog } from "../models/filters/filter-withholding-catalog";

@Injectable({
  providedIn: 'root'
})
export class WithholdingCatalogService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/withholdingsCatalog'; 

  findAllPageableWithholdingCatalog(filterWithholdingCatalog: FilterWithholdingCatalog, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterWithholdingCatalog);
  }

  findWithholdingCatalogById(id: number): Observable<Withholding> {
    return this.http.get<Withholding>(`${this.url}/${id}`);
  }

  createWithholdingCatalog(withholding: Withholding): Observable<Withholding>{
    return this.http.post<Withholding>(this.url, withholding);
  }

  updateWithholdingCatalog(withholding: Withholding): Observable<Withholding>{
    return this.http.put<Withholding>(`${this.url}/${withholding.id}`, withholding);
  }

}